export default __webpack_public_path__ + "static/media/isabellakits.MP.5a4e73e1.jpg";